import api from 'api'
import { WORK_ORDER_CACHE_INVALIDATION_TAGS, withDelayedWorkOrderInvalidation } from 'api/cacheInvalidationTagSets'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    regenerateInvoiceList: build.mutation({
      query: body => ({ url: '/api/v1/billing/invoice/regenerate', method: 'POST', body }),
      invalidatesTags: [...WORK_ORDER_CACHE_INVALIDATION_TAGS],
      onQueryStarted: withDelayedWorkOrderInvalidation({ api }),
    }),
  }),
})

export const { useRegenerateInvoiceListMutation } = extendedApi
